import en from '../intl/locales/en/translation.json';
import { getLinkInBioLabels } from './getLinkInBioLabels';

export function getEnglishLinkInBioLabels() {
  return getLinkInBioLabels(en, en);
}
